const productMetafields = `
enquiryOnly: metafield(namespace: "bms", key: "enquiry_only") {
  key
  value
}
priceHidden: metafield(namespace: "bms", key: "price_hidden") {
  key
  value
}
relatedProducts: metafield(namespace: "bms", key: "related_products") {
  key
  value
}
quantityInputEnabled: metafield(namespace: "bms", key: "quantity_input_enabled") {
  key
  value
}
`

const productItemBody = `
  title
  handle
  vendor
  productType
  availableForSale
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first: 1) {
    edges {
      node {
        originalSrc
        transformedSrc (maxWidth: $imgMaxW)
        altText
      }
    }
  }
  tags
  variants (first:1) {
    edges {
      node {
        # availableForSale
        # use product.priceRange....
        # priceV2 {
          # amount
        # }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  options {
    name
    values
  }
  ${productMetafields}
`

const productBody = `
  availableForSale
  title
  handle
  vendor
  productType
  description
  descriptionHtml
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first:20) {
    edges {
      node {
        altText
        originalSrc
        transformedSrc (maxWidth: $imgMaxW)
        meta: transformedSrc (maxWidth: 1200)
      }
    }
  }
  options {
    name
    values
  }
  variants (first:12) {
    edges {
      node {
        availableForSale
        
        id
        title
        price {
          amount
        }
        image {
          altText
          originalSrc
          transformedSrc (maxWidth: $imgMaxW)
        }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  collections (first:3) {
    edges {
      node {
        handle
        title
      }
    }
  }
  ${productMetafields}
`

const checkoutBody = `
  id
  checkoutUrl
  cost {
    subtotalAmount {
      amount
    }
    totalAmount {
      amount
    }
  }
  lines (first:250) {
    edges {
      node {
        id
        quantity
        variant: merchandise {
          ... on ProductVariant {
            availableForSale
            id
            title
            price {
              amount
            }
            image {
              altText
              transformedSrc (maxWidth: 885)
            }
          }
        }
      }
    }
  }
`

export const queryProducts = (full = false) => `
  query ($first: Int!, $after: String, $query: String, $imgMaxW: Int, $sortKey: ProductSortKeys, $reverse: Boolean) {
    products (first: $first, query: $query, after: $after, sortKey: $sortKey, reverse: $reverse) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ${full ? productBody : productItemBody}
        }
      }
    }
  }
`

export const queryProduct = `
  query ($handle: String!, $imgMaxW: Int) {
    productByHandle (handle: $handle) {
      ${productBody}
    }
  }
`

export const queryCheckout = `
  query ($id: ID!) {
    node: cart(
      id: $id
    ) {
      ${checkoutBody}
    }
  }
`
export const mutateCreateCheckout = `
  mutation cartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        ${checkoutBody}
      }
    }
  }
`

export const mutateCheckoutItems = `
  mutation cartLinesUpdate($id: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate (cartId: $id, lines: $lines) {
      cart {
        ${checkoutBody}
      }
    }
  }
`

export const mutateCartAdd = `
  mutation cartLinesAdd($id: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $id, lines: $lines) {
      cart {
        ${checkoutBody}
      }
    }
  }
`

export const queryCollection = `
  query ($handle: String!, $first: Int!, $after: String, $imgMaxW: Int, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
    collectionByHandle (handle: $handle) {
      title
      handle
      description
      descriptionHtml
      products (first:$first, after: $after, sortKey: $sortKey, reverse: $reverse) {
        pageInfo {
          hasNextPage
        },
        edges {
          cursor
          node {
            ${productItemBody}
          }
        }
      }
    }
  }
`
